export default __webpack_public_path__ + "static/media/logoCO.c28eecfe.png";